module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/dedication#ded"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Map")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PROLOGUE:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("North")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER ONE:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Different Directions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER TWO:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("“A Land of Ice”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER THREE:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("A Cold Addiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER FOUR:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Treasure Island")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER FIVE:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Colonizing Dreams")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER SIX:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Kodlunarn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER SEVEN:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Battles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER EIGHT:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Destinations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#nt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#in",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Also by Robert Ruby")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0